<template>
  <div>
    <b-container fluid class="p-0">
      <main>
        <div>
          <dl class="d-flex justify-content-between align-items-start m-0">
            <dt style="display: inline-block;">
              <CommonTitle class="sp-h2-font-size fs-24-bold" :titleProps="'お客様情報の確認'" :colorClassProps="'h1-mypage-left-line'"/>
            </dt>
            <dd style="display: inline-block; font-size: 8px !important;">
              <b-button pill variant="transparent" href="/mypage/change_request/input" class="d-block fs-14-bold d-sm-none btn-sm bg-primary text-white" style="max-width: 116px;margin-left:9px;" type="button">変更を依頼する</b-button>
            </dd>
            <b-button pill variant="transparent" href="/mypage/change_request/input" class="d-none fs-14-bold d-sm-block bg-primary text-white" style="max-width: 250px;" type="submit">変更を依頼する</b-button>
          </dl>
        </div>
        <!-- コンテンツ領域 -->
        <b-card>
          <!-- お客様のコース情報 -->
          <b-col cols="12" class="p-0">
            <h3 class="d-flex justify-content-between align-items-center fs-18-bold pb-1" style="border-bottom: 0 solid #000;">
              関連会社及び主要お取引先確認
            </h3>
              <div class="border-bottom-secondary-1 mb-3 px-1" v-for="(relationClients, index) in relationClients" :key="index">
                <b-row>
                  <b-col md="6" sm="12" class="mb-3 px-2">
                    <dl class="info border-bottom-secondary-dashed-2 h-100 m-0"><dt class="info-title d-block bg-transparent p-0 fs-12-bold">会社名</dt><dd class="info-desc d-block fs-14-regular">{{ relationClients.corporate_name }}</dd></dl>
                  </b-col>
                  <b-col md="6" sm="12" class="mb-3 px-2">
                    <dl class="info border-bottom-secondary-dashed-2 h-100 m-0"><dt class="info-title d-block bg-transparent p-0 fs-12-bold">担当者</dt><dd class="info-desc fs-14-regular">{{ relationClients.name }}</dd></dl>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="6" sm="12" class="mb-3 px-2">
                    <dl class="info border-bottom-secondary-dashed-2 h-100 m-0"><dt class="info-title d-block bg-transparent p-0 fs-12-bold">連絡先TEL</dt><dd class="info-desc d-block fs-14-regular">{{ relationClients.telephone_number }}</dd></dl>
                  </b-col>
                  <b-col md="6" sm="12" class="mb-3 px-2">
                    <dl class="info border-bottom-secondary-dashed-2 h-100 m-0"><dt class="info-title d-block bg-transparent p-0 fs-12-bold">更新日時</dt><dd class="info-desc fs-14-regular">{{ relationClients.updated_timestamp.replace(/\/\s/g, ' ').replace(/:\d{2}$/, '') }}</dd></dl>
                  </b-col>
                </b-row>
              </div>
          </b-col>
        </b-card>
      </main>
    </b-container>
    <!-- ローディング -->
    <b-modal centered :title="isLoadingTxt" v-model="loadingModalShow" hide-header hide-footer hide-header-close no-close-on-backdrop no-close-on-esc>
      <CommonLoader :title="isLoadingTxt"/>
    </b-modal>
  </div>
</template>
<script>

// NOTE: ローディングの共通文言を取得
import LoadingTxt from '../../utils/loading-text-util'

// NOTE: 共通タイトルUI
import CommonTitle from '../../components/common/CommonTitle'

// NOTE: トーストの共通文言を取得
import ToastTextUtil from '../../utils/toast-text-util'

// NOTE: 共通エラー処理
import ErrorHandleUtil from '@/utils/error-handle-util'
import CommonLoader from '@/components/common/CommonLoader.vue'

export default {
  components: {
    CommonLoader,
    CommonTitle
  },
  data () {
    return {
      tasId: '',
      last_login_date: '',
      account_id: '',
      isLoadingTxt: '',
      loadingModalShow: false,

      relationClients: []
    }
  },
  mounted () {
    this.getUserRelationClientSetting()
    this.$emit('executionUnreadCount')
    this.tasId = sessionStorage.getItem('tas_id')
    this.account_id = sessionStorage.getItem('account_id')
    document.querySelector('.main-setting').scrollTop = 0
  },
  methods: {
    /**
     * お客様情報をAPIで取得
     * */
    getUserRelationClientSetting () {
      // APIでアイテム取得
      this.isLoadingTxt = LoadingTxt.getTxt
      this.loadingModalShow = true
      let url = process.env.VUE_APP_BASE_API_URL + '/api/v1/mypage/getUserRelationClientSetting'
      this.$axios.request({
        method: 'get',
        url: `${url}`,
        params: {
          customer_id: sessionStorage.getItem('customer_id')
        },
        withCredentials: true }).then(response => {
        if (response.data.result_code === 403) {
          // セッション切れたのでログイン画面に飛ぶ
          if (this.$route.path !== '/mypage/login') this.$router.push({ path: '/mypage/login' })
        }
        if (response.data.error_message) {
          // 取得失敗
          this.$bvToast.toast(
            response.data.error_message,
            {
              title: ToastTextUtil.errorTitle,
              variant: 'danger',
              noAutoHide: true,
              toaster: 'b-toaster-top-center'
            }
          )
        }
        if (response.data.code === 2000) {
          // 取得成功
          this.relationClients = response.data.relation_client_setting.customer_clients
        }
      }).catch(err => {
        console.log(err)
        if (ErrorHandleUtil.authErrorHandle(err, this.$route.path, this.$router)) return
        this.$bvToast.toast(
          '通信エラー',
          {
            title: ToastTextUtil.errorTitle,
            variant: 'danger',
            noAutoHide: true,
            toaster: 'b-toaster-top-center'
          }
        )
      }).finally(() => {
        if (this.payment_method_now_changing_flag_front !== 0) {
          this.loadingModalShow = false
        } else {
          this.loadingModalShow = false
        }
      })
    },
    isEmpty (obj) {
      if (obj === null) {
        return true
      }
      return !Object.keys(obj).length
    },
    zeroFill (number) {
      return ('000' + number).slice(-3)
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@media screen and (max-width: 480px) {
    .sp-h1-font-size {
      font-size: 1.5rem !important;
    }
    .sp-h2-font-size {
      font-size: 1.25rem !important;
    }
    .sp-h3-font-size {
      font-size: 1.2rem !important;
    }
    .sp-botton-font-size {
      font-size: 0.6rem !important;
    }
    .sp-table-label-font-size {
      font-size: 0.8rem !important;
    }
    .info {
      display: flex;
      flex-direction: column;
    }
    .info-title {
      width: max-content;
    }
}
.info {
  margin-bottom: 0.75rem;
}
.info-title {
  display: inline-block;
  background: #999;
  font-weight: normal;
  color: #fff;
  height: 24px;
  line-height: 24px;
  padding: 0 6px;
  border-radius: 1px;
  margin-right: 16px;
}

.info-desc {
  display: inline-block;
  margin-bottom: 0;
}

</style>
